// extracted by mini-css-extract-plugin
export default {"button":"styles_button__0Bklk","icon":"styles_icon__1HUcb"};